import React from 'react';

import StoryTitle from './story-title';
import StoryView from './story-view';

export default function() {
	return (
		<div id="story-container">
			<StoryTitle />
			<StoryView />
		</div>
	);
}



// WEBPACK FOOTER //
// ./src/components/story-container.jsx